import { toAbsoluteUrl } from '../utils/assets';
import React from 'react';
import SVG from 'react-inlinesvg';

type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
};

const InlineSvg: React.FC<Props> = ({ className = '', path, svgClassName = 'mh-30px' }) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  );
};

export { InlineSvg };
